<template></template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";

export default {
  name: "swal-remove-calciatore-assegnato",
  mixins: [mixins, toast],
  mounted() {
    db.on("swalRemoveCalciatoreAssegnato", this.show);
  },
  destroyed() {
    db.off("swalRemoveCalciatoreAssegnato", this.show);
  },
  methods: {
    show({ id_calciatore, id_squadra, prezzo }) {
      const calciatore = this.calciatori[id_calciatore];
      if (!calciatore) {
        this.errorToast("Errore", "Calciatore non trovato");
        return;
      }

      Swal.fire({
        title:
          "Vuoi rimettere " +
          calciatore.calciatore +
          " tra gli svincolati?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed == true) {
          db.rimuoviCalciatoreAssegnato(id_calciatore, id_squadra)
            .then(() => {
              this.astaLogRemove(id_calciatore, id_squadra, prezzo || "");
            })
            .then(() => {
              this.reactivateSquadre(id_squadra);
            })
            .catch(() => {
              this.errorToast("Errore", "Operazione non consentita!");
            });
        }
      });
    },
  },
};
</script>
<style></style>
